export default __webpack_public_path__ + "static/media/external-link.c06a82f3.svg";